// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--q9b7V";
export var learn__more__button = "styles-module--learn__more__button--bVKtD";